import { useSearchParams, Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function CheckoutCancelPage() {
  const [searchParams] = useSearchParams();
  const listingId = searchParams.get('listing_id');

  return (
    <div className="min-h-screen bg-white dark:bg-zinc-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-zinc-900 rounded-2xl shadow-sm border border-gray-200 dark:border-zinc-800 p-8 max-w-md w-full text-center">
        <XCircle className="h-12 w-12 text-gray-500 dark:text-zinc-500 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-gray-900 dark:text-zinc-100 mb-2">Checkout cancelled</h1>
        <p className="text-gray-500 dark:text-zinc-500 mb-6">
          Your payment was not processed and no charge was made.
        </p>
        <div className="flex flex-col gap-2">
          {listingId && (
            <Link to={`/listings/${listingId}`} className="btn-primary px-6 py-2.5">
              Return to listing
            </Link>
          )}
          <Link to="/marketplace" className="text-sm text-brand-600 dark:text-brand-400 hover:underline">
            Browse other listings
          </Link>
        </div>
      </div>
    </div>
  );
}
